export default "__VITE_ASSET__BvLdVs0m__"